import { render, staticRenderFns } from "./PermissionsAgent.vue?vue&type=template&id=3bc83a21&scoped=true"
import script from "./PermissionsAgent.vue?vue&type=script&lang=js"
export * from "./PermissionsAgent.vue?vue&type=script&lang=js"
import style0 from "./PermissionsAgent.vue?vue&type=style&index=0&id=3bc83a21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc83a21",
  null
  
)

export default component.exports